import type * as React from 'react';

import { SkeletonHeadline } from '@xing-com/skeleton';

export type CommentListSkeletonProps = {
  className?: string;
};

export const CommentListSkeleton: React.VFC<CommentListSkeletonProps> = ({
  className,
}) => {
  return (
    <SkeletonHeadline
      alignment="left"
      amountRows={1}
      size="small"
      className={className}
      data-qa="social-comment-list-skeleton"
    />
  );
};
